export enum NoRecommendationSlug {
  CUVVA = 'cuvva',
}

const NO_RECOMMENDATION: string[] = Object.values(NoRecommendationSlug);

export const showRecommendsBranding = (slug?: string): boolean =>
  !!slug && !NO_RECOMMENDATION.includes(slug);
